import React from "react";
import { Briefcase, FileText, BookOpen, TrendingUp } from "lucide-react";
import { Link } from "react-router-dom";

const FeaturesSection = () => {
  const features = [
    {
      icon: <Briefcase className="h-10 w-10 text-blue-600" />,
      title: "Job Search",
      description:
        "Discover thousands of job opportunities tailored to your skills and experience.",
      cta: "Find Jobs",
      color: "blue",
      link: "/jobs",
    },
    {
      icon: <BookOpen className="h-10 w-10 text-purple-600" />,
      title: "Interview Prep",
      description:
        "Access comprehensive interview guides and practice with top questions.",
      cta: "Start Preparing",
      color: "purple",
      link: "/prepare",
    },
    {
      icon: <FileText className="h-10 w-10 text-teal-600" />,
      title: "Resume Builder",
      description:
        "Create professional resumes with our easy-to-use builder and expert templates.",
      cta: "Build Resume",
      color: "teal",
      link: "/resume",
    },
    {
      icon: <TrendingUp className="h-10 w-10 text-orange-600" />,
      title: "Career Growth",
      description:
        "Get personalized advice and resources to advance your career.",
      cta: "Explore Resources",
      color: "orange",
      link: "/prepare",
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Everything You Need For Your Career
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            ThoughtCode provides all the tools and resources you need to advance
            your tech career, from job search to interview preparation.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <FeatureCard key={index} feature={feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

const FeatureCard = ({ feature }) => {
  const bgColors = {
    blue: "bg-blue-50 hover:bg-blue-100",
    purple: "bg-purple-50 hover:bg-purple-100",
    teal: "bg-teal-50 hover:bg-teal-100",
    orange: "bg-orange-50 hover:bg-orange-100",
  };

  const borderColors = {
    blue: "border-blue-200",
    purple: "border-purple-200",
    teal: "border-teal-200",
    orange: "border-orange-200",
  };

  return (
    <div
      className={`rounded-xl ${bgColors[feature.color]} border ${
        borderColors[feature.color]
      } p-6 transition-all duration-300 hover:shadow-md flex flex-col h-full`}
    >
      <div className="mb-4">{feature.icon}</div>
      <h3 className="text-xl font-semibold mb-3">{feature.title}</h3>
      <p className="text-gray-600 mb-6 flex-grow">{feature.description}</p>
      <Link
        to={feature.link}
        className="no-underline text-blue-600 font-medium hover:text-blue-800 flex items-center transition-colors"
      >
        {feature.cta}
        <svg
          className="w-4 h-4 ml-1"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 12H19M19 12L12 5M19 12L12 19"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Link>
    </div>
  );
};

export default FeaturesSection;
